import { render, staticRenderFns } from "./LeaveUploadsConfirm.vue?vue&type=template&id=0fb83a6e&scoped=true&"
import script from "./LeaveUploadsConfirm.vue?vue&type=script&lang=js&"
export * from "./LeaveUploadsConfirm.vue?vue&type=script&lang=js&"
import style0 from "./LeaveUploadsConfirm.vue?vue&type=style&index=0&id=0fb83a6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb83a6e",
  null
  
)

export default component.exports